import React, { useState } from "react";
import {
  Button,
  TextField, // Used instead of TextareaAutosize
  InputLabel,
  DialogTitle,
  Dialog,
  Select,
  Box,
  MenuItem,
  FormControl,
  Typography,
  IconButton,
} from "@mui/material";
import { useTheme } from "@mui/material/styles"; // Import useTheme
import { addNewDirection, saveCurrentRecipe } from "../actions/recipes";
import { useDispatch } from "react-redux";
import { Close } from "@mui/icons-material";

// Removed: import { makeStyles } from "@mui/styles";
// Removed: useStyles definition

function AddDirection(props) {
  const { onClose, open } = props;
  const dispatch = useDispatch();
  const theme = useTheme(); // Access the theme

  const [optional, setOptional] = useState(false);
  const [instruction, setInstruction] = useState("");
  const [openOptions, setOptionsOpen] = React.useState(false);

  // --- Handlers ---
  const handleClose = () => {
    // Reset state before closing
    setInstruction("");
    setOptional(false);
    onClose();
  };

  const handleOptionsClose = () => setOptionsOpen(false);
  const handleInstructionChange = (e) => setInstruction(e.target.value);
  const handleOptionsOpen = () => setOptionsOpen(true);
  const handleOptionsChange = (e) => setOptional(e.target.value);

  // --- Submission Logic ---
  function addDirection() {
    if (!instruction) {
      alert("Please enter an instruction.");
      return;
    }

    const newDirection = {
      instruction,
      optional,
    };

    dispatch(addNewDirection(newDirection));
    dispatch(saveCurrentRecipe());
    handleClose();
  }

  // Define styles using the sx prop
  const closeButtonStyle = {
    position: "absolute",
    right: theme.spacing(1),
    top: theme.spacing(1),
    color: theme.palette.grey[500],
  };

  return (
    <Dialog
      maxWidth={"xs"}
      fullWidth={true}
      onClose={handleClose}
      aria-labelledby="add-direction"
      open={open}
    >
      <DialogTitle
        id="add-direction"
        sx={{
          borderBottom: `1px solid ${theme.palette.divider}`,
          padding: theme.spacing(2, 3),
        }}
      >
        <Typography variant="h5" component="span" sx={{ fontWeight: 600 }}>
          ➕ Add New Direction
        </Typography>
        <IconButton
          aria-label="close"
          sx={closeButtonStyle}
          onClick={handleClose}
        >
          <Close />
        </IconButton>
      </DialogTitle>

      <Box
        component="form"
        noValidate
        autoComplete="off"
        sx={{
          p: 4,
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
        }}
      >
        <FormControl fullWidth sx={{ mb: 3 }}>
          <TextField
            label="Instruction Step"
            placeholder="Enter a step-by-step instruction"
            multiline
            rows={4}
            onChange={handleInstructionChange}
            value={instruction}
          />
        </FormControl>

        <FormControl fullWidth sx={{ mb: 2 }}>
          <InputLabel id="optional-label">Optional Step?</InputLabel>
          <Select
            labelId="optional-label"
            id="optional-select"
            label="Optional Step?"
            open={openOptions}
            onClose={handleOptionsClose}
            onOpen={handleOptionsOpen}
            onChange={handleOptionsChange}
            value={optional} // Value should be boolean
          >
            <MenuItem value={false}>No</MenuItem>
            <MenuItem value={true}>Yes</MenuItem>
          </Select>
        </FormControl>
      </Box>

      <Box
        sx={{
          p: 3,
          display: "flex",
          justifyContent: "center",
          borderTop: `1px solid ${theme.palette.divider}`,
        }}
      >
        <Button
          onClick={addDirection}
          size="large"
          variant="contained"
          color="primary"
          sx={{ padding: theme.spacing(1, 4) }}
        >
          Add Direction
        </Button>
      </Box>
    </Dialog>
  );
}
export default AddDirection;
